import { Plus } from "lucide-react";

export default function NotificacionesHeader({ title, subtitle, handleAdd }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
      <div>
        <h1 className="text-2xl font-bold text-gray-800 mb-1">{title}</h1>
        {/* <p className="text-gray-500 text-sm">{subtitle}</p> */}
        <button
          // className="flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-lg font-medium transition-colors shadow-sm cursor-pointer"
          className="flex items-center gap-2 bg-[#104063] hover:bg-[#0d3553] text-white px-4 py-2 rounded-lg font-medium transition-colors shadow-sm cursor-pointer"
          onClick={handleAdd}
        >
          <Plus className="w-4 h-4" />
          Nueva Notificación
        </button>
      </div>


      {/* Botón Nueva Notificación */}
      {/* <button
        // className="flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-lg font-medium transition-colors shadow-sm cursor-pointer"
        className="flex items-center gap-2 bg-[#104063] hover:bg-[#0d3553] text-white px-4 py-2 rounded-lg font-medium transition-colors shadow-sm cursor-pointer"
        onClick={handleAdd}
      >
        <Plus className="w-4 h-4" />
        Nueva Notificación
      </button> */}
    </div>
  );
}
